import React from 'react'
import { EducationFeature } from 'education-tools'
import QuestionMarkButton from './QuestionMarkButton'
import NeedHelpPopup from './NeedHelpPopup'
import ExperimentationFeaturePopups from './ExperimentationFeaturePopups'
import ErrorBoundary from './ErrorBoundary'

export default function HelpfulQuestionMark() {
  return (
    <EducationFeature name="meg.uhqm">
      <ErrorBoundary>
        <QuestionMarkButton />
      </ErrorBoundary>
      <ErrorBoundary>
        <NeedHelpPopup />
      </ErrorBoundary>
      <ErrorBoundary>
        <ExperimentationFeaturePopups />
      </ErrorBoundary>
    </EducationFeature>
  )
}
